import React from 'react';

import classes from './unread-notifications-counter.module.scss';

interface UnreadNotificationsCounterProps {
  count: number;

  onClick?: React.MouseEventHandler<HTMLDivElement>;
}

const UnreadNotificationsCounter = ({ count, onClick }: UnreadNotificationsCounterProps) => {
  const text = count === 0 ? '0' : `+ ${count}`;

  return (
    <div className={classes.badge} onClick={onClick}>
      {text}
    </div>
  );
};

export default UnreadNotificationsCounter;
